import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    margin: '1.875rem 0 0 !important',
    justifyContent: 'center !important',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06)',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between !important',
    padding: '.25rem 4rem .25rem 1rem',
  },
  button: {
    backgroundColor: 'transparent !important',
    borderRadius: 'none !important',
    color: `${theme.deepPurple} !important`,
    fontSize: '.75rem',
    fontWeight: '300',
    outline: 'none',
    whiteSpace: 'nowrap !important',
    margin: '.25rem 0 !important',
    padding: '0 !important',
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  buttonContainer: {
    display: 'flex',
    alginItems: 'center',
    marginTop: '.25rem',
    width: '100%',
    padding: '.25rem 4rem .25rem 1rem;',
  },
  selectAllHeader: {},
  selectionCount: {
    color: `${theme.violet} !important`,
  },
  venueList: {
    listStyleType: 'none',
    margin: '0 !important',
    padding: '0 !important',
    maxHeight: '40.625rem',
    overflowX: 'auto',
  },
  venueItem: {
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06)',
    display: 'flex !important',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 1rem 0 1.25rem !important',
    margin: '1.5rem 4rem 1.5rem 1rem !important',
  },
  venueContainer: {
    margin: '1.2rem 1rem',
  },
  venueName: {
    margin: '0',
    fontSize: '.975rem',
    color: `${theme.deepPurple}`,
  },
  venueAddress: {
    margin: '0',
    fontSize: '.875rem',
  },
  noVenueWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '.25rem 4rem .25rem 1rem',
    marginTop: '.25rem',
  },
  noVenue: {
    padding: '1.25rem 4rem .25rem 1rem !important',
  },
});

export default styles;
